import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-download-container',
  templateUrl: './download-container.component.html',
  styleUrls: ['./download-container.component.css']
})
export class DownloadContainerComponent implements OnInit {
  private sub: any;
  id: string;
  category : string;
  subcategory : string [];
 // gateway : string;
  //device : string;
  key : string [];// = ["R206", "R207"];
  //tool : string;
  
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      // this.id = +params['id']; // (+) converts string 'id' to a number
       this.id = params['id']; 
 
       console.log("id : " + this.id);
 
       if(this.isCategoryIoT())
       {
          this.category = "iot";
          this.subcategory = ["gateway", "device", "tool"];
          this.key = ["R206", "R207"];
        }
       else if(this.isCategoryAccessControl())
       {
          this.category = "actrl";
          this.subcategory = ["firmware", "sofrware"];
       }
       else if(this.isCategoryCCTV())
       {
          this.category = "cctv";
          this.subcategory = ["dvr-firmware", "camera-firmware", "software"];
       }


       // In a real app: dispatch action to load the details here.
    });
  }

  isCategoryIoT(){
    return (this.id == "iot");
  }

  isCategoryCCTV(){
    return (this.id == "cctv");
  }

  isCategoryAccessControl(){
    return (this.id == "actrl");
  }

}
